<template>
  <div>
    <!-- 多属性资料 -->
    <div class="tag-content-multiattribute tag-comtent-item" v-show="pageEditTag == 'multiattribute'">
      <!-- 商品多属性 -->
      <div class="productsCont normalTop" v-if="pageTagView['multiattribute']">
        <div class="productsTit padding-10">
          <div id="productProperty">
            商品多属性
          </div>
        </div>
        <div class="products-content padding-10">
          <div class="propertyCont"> <!-- 云卖网产品 -->
            <Button @click="editAttributes"
              v-if="!isDisabled && productInfo.type != 1 && productInfo.productCategoryId !== '615703264498811431'">编辑多属性</Button>
            <div v-if="!tableReady" style="text-align:center;padding:40px 0;color:#999;">加载中...</div>
            <Table v-else class="normalTop" :columns="skuColumns" :data="pagedSkuDataLocal" :disabled-hover="true" border></Table>
            <Page v-if="tableReady && skuDataLocal.length > skuPageSize" style="text-align: right; margin-top: 10px;" :current="skuPageNum" :page-size="skuPageSize" :total="skuDataLocal.length" show-elevator show-total @on-change="skuPageNum = $event" />
          </div>
        </div>
      </div>
    </div>

    <!-- 编辑多属性弹窗 -->
    <Modal v-model="editVisible" :mask-closable="false" title="编辑多属性" @on-cancel="closeEdit" @on-ok="saveEdit"
      width="800px">
      <Table :columns="columns1" :data="skuPropertyListLocal" :border="true">
        <template slot-scope="{ row }" slot="name">
          <div>
            {{ row.name }}
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="value">
          <div id="customTagInput">
            <template v-for="(value, index1) in row.values">
              <Tag v-if="index === 0" closable :key="`color-${index1}`"
                @on-close="delSkuPropertyValue(skuPropertyListLocal[index], value, index1)"
                :style="`margin-left:4px;${getColorAll.includes(value) || isOldData ? '' : 'border:1px solid #f30;'}`">
                {{ value }}
              </Tag>
              <Tag v-else-if="index === 1" closable :key="`size-${index1}`"
                @on-close="delSkuPropertyValue(skuPropertyListLocal[index], value, index1)"
                :style="`margin-left:4px;${getSizeVal.includes(value) || isOldData ? '' : 'border:1px solid #f30;'}`">
                {{ value }}
              </Tag>
              <Tag v-else closable :key="`tag-${index1}`"
                @on-close="delSkuPropertyValue(skuPropertyListLocal[index], value, index1)" style="margin-left:4px;">
                {{ value }}
              </Tag>
            </template>

            <Input
              v-if="!skuPropertyListLocal[index].isEdit && [0, 1, '0', '1'].includes(index) && (sizeList.length == 0 || isOldData)"
              class="inputValue" :disabled="row.isEdit" :ref="row.name" :maxlength="100"
              @keyup.native.enter="addSkuPropertyValue(skuPropertyListLocal[index], index, 1)" placeholder="请输入属性值，按回车确认" />
            <Select
              v-if="skuPropertyListLocal[index] && !skuPropertyListLocal[index].isEdit && sizeList.length != 0 && index === 0 && !isOldData"
              class="inputValue" filterable :ref="row.name" placeholder="请选择商品颜色"
              @on-change="addSkuPropertyValue(skuPropertyListLocal[index], index, 2)" :transfer="true">
              <Option v-for="(sitem, sindex) in colorList" :value="sitem.color" :key="sindex">{{ sitem.color }}</Option>
            </Select>
            <Cascader v-if="!skuPropertyListLocal[index].isEdit && sizeList.length != 0 && index === 1 && !isOldData"
              class="inputValue" filterable :data="sizeList" :ref="row.name" placeholder="请选择商品尺码"
              @on-change="addSkuPropertyValue(skuPropertyListLocal[index], index, 3)" :transfer="true">
            </Cascader>
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="operate">
          <div>
            <Icon type="md-add-circle" style="font-size:25px" @click="addAttribute(skuPropertyListLocal[index])" />
          </div>
        </template>
      </Table>
      <div v-if="isAttrTips" style="padding:10px 10px 0px 10px; color:#f30;font-size: 12px;">
        红色边框的属性不可用，新增多属性时，不再生成该属性的多属性信息</div>
    </Modal>
  </div>
</template>

<script>
import commonMixin from '@/components/mixin/common_mixin';
import productMixin from '@/components/mixin/product_mixin';
import { productTypeData } from '@/utils/comConfig';

export default {
  name: 'ProductMultiattribute',
  mixins: [commonMixin, productMixin],
  props: {
    productInfo: {
      type: Object,
      default: () => ({})
    },
    skuData: {
      type: Array,
      default: () => []
    },
    skuPropertyList: {
      type: Array,
      default: () => []
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    pageEditTag: {
      type: String,
      default: ''
    },
    pageTagView: {
      type: Object,
      default: () => ({})
    },
    customProductTagList: {
      type: Array,
      default: () => []
    },
    productStatus: {
      type: Array,
      default: () => []
    },
    treeSelectCategoryJson: {
      type: Object,
      default: () => ({})
    },
    textTalg: {
      type: String,
      default: ''
    },
    columnSizeOrModel: {
      type: String,
      default: ''
    },
    initFinished: {
      type: Boolean,
      default: false
    },
    isOldData: {
      type: Boolean,
      default: false
    },
    sizeList: {
      type: Array,
      default: () => []
    },
    colorList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    const self = this;
    return {
      skuColumns: [
        {
          title: '图片',
          key: 'img',
          width: 160,
          fixed: 'left',
          align: 'center',
          render: (h, params) => {
            const realIndex = self.getRealIndex(params.index);
            const goodsImages = (self.productInfo.productGoodsList[realIndex] || {}).productGoodsImages || [];
            const langOrder = ['common', 'en', 'fr', 'de', 'ru', 'nl'];
            const langLabel = { common: '通', en: 'EN', fr: 'FR', de: 'DE', ru: 'RU', nl: 'NL' };
            // 按语言分组
            const langGroups = {};
            langOrder.forEach(l => { langGroups[l] = []; });
            goodsImages.forEach(img => {
              if (img.language && langGroups[img.language] !== undefined) {
                langGroups[img.language].push(img);
              }
            });
            const totalCount = goodsImages.length;
            // 按规则选取最多3张缩略图：
            // 1. 只有一个语言有图片时，取该语言前3张
            // 2. 多个语言有图片时，每个语言先取1张；若总数不足3张，再从有剩余图片的语言依次填充
            const langsWithImages = langOrder.filter(l => langGroups[l].length > 0);
            const showThumbs = [];
            if (langsWithImages.length === 1) {
              showThumbs.push(...langGroups[langsWithImages[0]].slice(0, 3));
            } else {
              // 第一轮：每个有图语言取1张
              langsWithImages.forEach(l => {
                if (showThumbs.length < 3) showThumbs.push(langGroups[l][0]);
              });
              // 第二轮：按语言顺序依次取剩余图片填充到3张
              let round = 1;
              while (showThumbs.length < 3) {
                let added = false;
                langsWithImages.forEach(l => {
                  if (showThumbs.length < 3 && langGroups[l][round]) {
                    showThumbs.push(langGroups[l][round]);
                    added = true;
                  }
                });
                if (!added) break;
                round++;
              }
            }
            // 缩略图节点
            const thumbImgNodes = showThumbs.map(img =>
              h('img', {
                attrs: { src: self.filenodeViewTargetUrl + img.path },
                style: { width: '32px', height: '32px', margin: '1px', objectFit: 'cover', borderRadius: '2px' }
              })
            );
            // 无图片时显示占位
            if (showThumbs.length === 0) {
              thumbImgNodes.push(h('img', {
                attrs: { src: self.placeholderSrc },
                style: { width: '32px', height: '32px', margin: '1px', opacity: '0.4' }
              }));
            }
            // 总图数角标
            const badgeNodes = totalCount > 0
              ? [h('span', { class: 'sku-img-badge' }, `${totalCount}图`)]
              : [];
            // 语言标签行
            const langTagNodes = langOrder.map(l =>
              h('span', { class: langGroups[l].length > 0 ? 'sku-lang-tag active' : 'sku-lang-tag' }, langLabel[l])
            );
            return h('div', {
              class: 'sku-img-cell',
              on: { click: () => self.$emit('edit-sku-image', realIndex) }
            }, [
              h('div', { class: 'sku-img-thumbs' }, [...thumbImgNodes, ...badgeNodes]),
              h('div', { class: 'sku-lang-tags' }, langTagNodes)
            ]);
          }
        },
        {
          title: 'Color',
          key: 'color',
          minWidth: 100,
          align: 'center',
          render: (h, { row }) => {
            const productAttribute = this.treeSelectCategoryJson[this.productInfo.productCategoryId];
            let rowVal = '';
            if (row.productGoodsSpecifications && row.productGoodsSpecifications[0] && !this.$common.isEmpty(row.productGoodsSpecifications[0].value)) {
              rowVal = row.productGoodsSpecifications[0].value;
            }
            if ([1, '1'].includes(this.$common.isEmpty(productAttribute) ? '' : productAttribute.productType || '')) {
              return h('Input', {
                props: {
                  value: rowVal,
                  maxlength: 100,
                  placeholder: '请输入Color',
                  disabled: (() => {
                    return self.isDisabled;
                  })()
                },
                on: {
                  'input': (val) => {
                    rowVal = self.trim(val);
                  },
                  'on-blur': (val) => {
                    let newVal = [];
                    const oldRowVal = row.productGoodsSpecifications && row.productGoodsSpecifications[0] ? row.productGoodsSpecifications[0].value || '' : '';
                    // 操作本地副本，避免直接突变 prop
                    this.skuDataLocal.forEach((item, index) => {
                      if (item.productGoodsSpecifications && item.productGoodsSpecifications[0] && oldRowVal === item.productGoodsSpecifications[0].value) {
                        this.$set(this.skuDataLocal[index].productGoodsSpecifications[0], 'value', rowVal);
                      }
                    })
                    this.skuPropertyListLocal[0].values.forEach(item => {
                      newVal.push(oldRowVal === item ? rowVal : item);
                    })
                    this.$set(this.skuPropertyListLocal[0], 'values', newVal);
                    this.productInfo.productGoodsList = this.deepCopy(this.skuDataLocal);
                    this.saveEdit();
                  }
                }
              });
            }
            return h('div', {}, rowVal);
          }
        },
        {
          title: `${this.columnSizeOrModel}`,
          key: 'size',
          minWidth: 100,
          align: 'center',
          renderHeader: (h, params) => {
            return h('div', {
            }, this.columnSizeOrModel);
          },
          render: (h, { row }) => {
            const productAttribute = this.treeSelectCategoryJson[this.productInfo.productCategoryId];
            let rowVal = '';
            if (row.productGoodsSpecifications && row.productGoodsSpecifications[1] && !this.$common.isEmpty(row.productGoodsSpecifications[1].value)) {
              rowVal = row.productGoodsSpecifications[1].value;
            }
            if ([1, '1'].includes(this.$common.isEmpty(productAttribute) ? '' : productAttribute.productType || '')) {
              return h('Input', {
                props: {
                  value: rowVal,
                  maxlength: 100,
                  placeholder: '请输入Size',
                  disabled: (() => {
                    return self.isDisabled;
                  })()
                },
                on: {
                  'input': (val) => {
                    rowVal = self.trim(val);
                  },
                  'on-blur': (val) => {
                    let newVal = [];
                    const oldRowVal = row.productGoodsSpecifications && row.productGoodsSpecifications[1] ? row.productGoodsSpecifications[1].value || '' : '';
                    // 操作本地副本，避免直接突变 prop
                    this.skuDataLocal.forEach((item, index) => {
                      if (item.productGoodsSpecifications && item.productGoodsSpecifications[1] && oldRowVal === item.productGoodsSpecifications[1].value) {
                        this.$set(this.skuDataLocal[index].productGoodsSpecifications[1], 'value', rowVal);
                      }
                    })
                    this.skuPropertyListLocal[1].values.forEach(item => {
                      newVal.push(oldRowVal === item ? rowVal : item);
                    });
                    this.$set(this.skuPropertyListLocal[1], 'values', newVal);
                    this.productInfo.productGoodsList = this.deepCopy(this.skuDataLocal);
                    this.saveEdit();
                  }
                }
              });
            }
            return h('div', {}, rowVal);
          }
        },
        {
          title: 'SKU',
          key: 'sku',
          width: 90,
          align: 'center',
          renderHeader: (h, params) => {
            return h('div', {
            }, params.column.title);
          },
          render: (h, params) => {
            const realIndex = self.getRealIndex(params.index);
            return h('div', [
              h('Input', {
                props: {
                  placeholder: '请输入' + 'SKU',
                  maxlength: 100,
                  value: self.productInfo.productGoodsList[realIndex].sku,
                  disabled: true
                },
                on: {
                  'input': (val) => {
                    const trimVal = self.trim(val);
                    self.productInfo.productGoodsList[realIndex].sku = trimVal;
                    if (self.skuDataLocal[realIndex]) self.$set(self.skuDataLocal[realIndex], 'sku', trimVal);
                  }
                }
              })
            ]);
          }
        },
        {
          title: 'SKC',
          key: 'skc',
          width: 85,
          align: 'center',
          renderHeader: (h, params) => {
            return h('div', {
            }, params.column.title);
          },
          render: (h, params) => {
            const realIndex = self.getRealIndex(params.index);
            return h('div', [
              h('Input', {
                props: {
                  placeholder: '请输入SKC',
                  maxlength: 100,
                  value: self.productInfo.productGoodsList[realIndex].skc,
                  disabled: true
                },
                on: {
                  'input': (val) => {
                    self.productInfo.productGoodsList[realIndex].skc = val;
                    if (self.skuDataLocal[realIndex]) self.$set(self.skuDataLocal[realIndex], 'skc', val);
                  }
                }
              })
            ]);
          }
        },
        {
          title: '重量',
          key: 'weight',
          width: 80,
          align: 'center',
          renderHeader: (h, params) => {
            return self.checkIdenticalDon(h, params, '重量', self.productInfo.productGoodsList, 'weight', this.skuDataLocal);
          },
          render: (h, params) => {
            const realIndex = self.getRealIndex(params.index);
            return h('InputNumber', {
              props: {
                min: 0,
                precision: 0,
                value: self.productInfo.productGoodsList[realIndex].weight || 0,
                disabled: (() => {
                  return self.isDisabled;
                })()
              },
              class: `isWeight-${realIndex}`,
              style: {
                width: '70px'
              },
              on: {
                'input': (val) => {
                  self.productInfo.productGoodsList[realIndex].weight = val;
                  if (self.skuDataLocal[realIndex]) self.$set(self.skuDataLocal[realIndex], 'weight', val);
                }
              }
            });
          }
        },
        {
          title: '尺寸（长，宽，高）cm',
          key: 'spuTableSize',
          width: 140,
          align: 'center',
          renderHeader: (h, params) => {
            return self.checkIdenticalDon(h, params, '尺寸（长，宽，高）cm', self.productInfo.productGoodsList, [
              'length', 'width', 'height'
            ], this.skuDataLocal);
          },
          render: (h, params) => {
            const realIndex = self.getRealIndex(params.index);
            return h('div', { style: { display: 'flex', flexDirection: 'column' } }, [
              h('div', [
                h('span', {}, '长：'),
                h('InputNumber', {
                  style: {
                    width: '70px',
                    margin: '5px 0'
                  },
                  props: {
                    min: 0,
                    value: self.productInfo.productGoodsList[realIndex].length || 0,
                    placeholder: '长',
                    disabled: (() => {
                      return self.isDisabled;
                    })()
                  },
                  class: `isLength-${realIndex}`,
                  on: {
                    'input': (val) => {
                      self.productInfo.productGoodsList[realIndex].length = val;
                      if (self.skuDataLocal[realIndex]) self.$set(self.skuDataLocal[realIndex], 'length', val);
                    }
                  }
                })
              ]),
              h('div', [
                h('span', {}, '宽：'),
                h('InputNumber', {
                  style: {
                    width: '70px',
                    margin: '5px 0'
                  },
                  props: {
                    min: 0,
                    value: self.productInfo.productGoodsList[realIndex].width || 0,
                    placeholder: '宽',
                    disabled: (() => {
                      return self.isDisabled;
                    })()
                  },
                  class: `isWidth-${realIndex}`,
                  on: {
                    'input': (val) => {
                      self.productInfo.productGoodsList[realIndex].width = val;
                      if (self.skuDataLocal[realIndex]) self.$set(self.skuDataLocal[realIndex], 'width', val);
                    }
                  }
                })
              ]),
              h('div', [
                h('span', {}, '高：'),
                h('InputNumber', {
                  style: {
                    width: '70px',
                    margin: '5px 0'

                  },
                  props: {
                    min: 0,
                    value: self.productInfo.productGoodsList[realIndex].height || 0,
                    placeholder: '高',
                    disabled: (() => {
                      return self.isDisabled;
                    })()
                  },
                  class: `isHeight-${realIndex}`,
                  on: {
                    'input': (val) => {
                      self.productInfo.productGoodsList[realIndex].height = val;
                      if (self.skuDataLocal[realIndex]) self.$set(self.skuDataLocal[realIndex], 'height', val);
                    }
                  }
                })
              ])
            ]);
          }
        },
        {
          title: '特性标签',
          key: 'tagName',
          align: 'center',
          minWidth: 200,
          renderHeader: (h, params) => {
            return self.checkIdenticalDon(h, params, '特性标签', self.productInfo.productGoodsList, 'productGoodsTags', this.skuDataLocal);
          },
          render: (h, params) => {
            const realIndex = self.getRealIndex(params.index);
            let productTagBox = [];
            self.customProductTagList.forEach((n, i) => {
              productTagBox.push(h('Option', {
                props: {
                  value: n
                }
              }, n));
            });
            let productLabelSelect = h('Select', {
              props: {
                placeholder: '请选择' + '特性标签',
                filterable: true,
                transfer: true,
                multiple: true,
                value: self.productInfo.productGoodsList[realIndex].productGoodsTags,
                disabled: (() => {
                  return self.isDisabled;
                })()
              },
              on: {
                'on-enter': (event) => {
                  let productGoodsTagsSelectInput = event.target;
                  let value = productGoodsTagsSelectInput.value === null
                    ? ''
                    : self.trim(productGoodsTagsSelectInput.value);
                  if (value !== '' && value.length <= 50 && self.customProductTagList.indexOf(value) === -1) {
                    self.customProductTagList.push(value);
                    self.productInfo.productGoodsList[realIndex].productGoodsTags.push(value);
                    if (self.skuDataLocal[realIndex]) self.$set(self.skuDataLocal[realIndex], 'productGoodsTags', [...self.productInfo.productGoodsList[realIndex].productGoodsTags]);
                  } else {
                    self.$Message.error('新增标签长度不能超过50且不能与已存在标签重复');
                  }
                },
                'on-change': (event) => {
                  self.productInfo.productGoodsList[realIndex].productGoodsTags = event;
                  if (self.skuDataLocal[realIndex]) self.$set(self.skuDataLocal[realIndex], 'productGoodsTags', event);
                }
              }
            }, productTagBox);
            return productLabelSelect;
          }
        },
        {
          title: self.textTalg,
          key: 'suggestPrice',
          minWidth: 80,
          align: 'center',
          renderHeader: (h, params) => {
            return self.checkIdenticalDon(h, params, self.textTalg, self.productInfo.productGoodsList, 'suggestPrice', this.skuDataLocal);
          },
          render: (h, params) => {
            const realIndex = self.getRealIndex(params.index);
            return h('InputNumber', {
              props: {
                min: 0,
                value: self.productInfo.productGoodsList[realIndex].suggestPrice || 0,
                disabled: (() => {
                  return self.isDisabled;
                })()
              },
              style: {
                width: '60px'
              },
              on: {
                'input': (val) => {
                  self.productInfo.productGoodsList[realIndex].suggestPrice = val;
                  if (self.skuDataLocal[realIndex]) self.$set(self.skuDataLocal[realIndex], 'suggestPrice', val);
                }
              }
            });
          }
        },
        {
          title: '分销',
          key: 'distributionPriceValue',
          minWidth: 80,
          align: 'center',
          renderHeader: (h, params) => {
            return this.checkIdenticalDon(h, params, '分销', this.productInfo.productGoodsList, ['distributionPriceType', 'distributionPriceValue'], this.skuDataLocal);
          },
          render: (h, { row, index }) => {
            const realIndex = self.getRealIndex(index);
            let text = '';
            if (this.$common.isEmpty(row.distributionPriceType) || this.$common.isEmpty(row.distributionPriceValue)) {
              text = `0${(this.$common.isEmpty(row.distributionPriceType) || row.distributionPriceType == 1) ? ' %' : ''}`;
            } else {
              const distributionPriceValue = Number(row.distributionPriceValue);
              const isMaxZeno = distributionPriceValue > 0;
              if (distributionPriceValue == 0) {
                text = `${distributionPriceValue} ${row.distributionPriceType == 1 ? '%' : ''}`;
              } else {
                text = `${isMaxZeno ? '+' : '-'} ${distributionPriceValue * (isMaxZeno ? 1 : -1)}${row.distributionPriceType == 1 ? ' %' : ''}`;
              }
            }
            let item = [h('div', {
              style: {
                'line-height': '20px'
              },
            }, text)];
            if (!this.isDisabled) {
              item.push(h('div', {
                style: {
                  'cursor': 'pointer',
                  'text-decoration': 'underline',
                  'color': '#2d8cf0',
                  'line-height': '20px'
                },
                on: {
                  'click': () => {
                    this.$emit('edit-distribution', { index: realIndex, row });
                  }
                }
              }, '修改'));
            }
            return h('div', item);
          }
        },
        {
          title: '商品状态',
          key: 'status',
          width: 90,
          align: 'center',
          renderHeader: (h, params) => {
            return self.checkIdenticalDon(h, params, '商品状态', self.productInfo.productGoodsList, 'status', this.skuDataLocal);
          },
          render: (h, params) => {
            const realIndex = self.getRealIndex(params.index);
            let list = []
            this.productStatus.forEach(item => {
              list.push(h('Option', {
                props: {
                  value: item.value
                }
              }, item.label))
            });
            return h('Select', {
              style: {
                width: '70px'
              },
              props: {
                transfer: true,
                value: self.productInfo.productGoodsList[realIndex].status === null || self.productInfo.productGoodsList[realIndex].status === undefined
                  ? 1
                  : self.productInfo.productGoodsList[realIndex].status,
                disabled: (() => {
                  return self.isDisabled;
                })()
              },
              on: {
                'input': (val) => {
                  self.productInfo.productGoodsList[realIndex].status = val;
                  if (self.skuDataLocal[realIndex]) self.$set(self.skuDataLocal[realIndex], 'status', val);
                }
              }
            }, list);
          }
        },
        {
          title: '组装信息',
          key: 'assemble',
          width: 90,
          align: 'center',
          renderHeader: (h, params) => {
            return self.checkIdenticalDon(h, params, '组装信息', self.productInfo.productGoodsList, [
              'isAssemble', 'productGoodsAssembles'
            ], this.skuDataLocal);
          },
          render: (h, params) => {
            const realIndex = self.getRealIndex(params.index);
            if (self.productInfo.productGoodsList[realIndex].isAssemble) {
              return h('div', [
                h('i-switch', {
                  props: {
                    value: !!self.productInfo.productGoodsList[realIndex].isAssemble,
                    disabled: (() => {
                      return self.isDisabled;
                    })()
                  },
                  on: {
                    'on-change': (val) => {
                      const assembleVal = !!val;
                      self.productInfo.productGoodsList[realIndex].isAssemble = assembleVal;
                      if (self.skuDataLocal[realIndex]) self.$set(self.skuDataLocal[realIndex], 'isAssemble', assembleVal);
                      // 开启组装时若 productGoodsAssembles 不存在，初始化为空数组
                      if (assembleVal && self.$common.isEmpty(self.productInfo.productGoodsList[realIndex].productGoodsAssembles)) {
                        self.$set(self.productInfo.productGoodsList[realIndex], 'productGoodsAssembles', []);
                        if (self.skuDataLocal[realIndex]) self.$set(self.skuDataLocal[realIndex], 'productGoodsAssembles', []);
                      }
                    }
                  }
                }), h('span', {
                  style: {
                    cursor: 'pointer',
                    color: '#0000FF',
                    marginLeft: '10px',
                    textDecoration: 'underline',
                    display: (() => {
                      if (self.isDisabled) {
                        return 'none';
                      } else {
                        return 'inline';
                      }
                    })()
                  },
                  on: {
                    click: () => {
                      self.$emit('edit-assemble', realIndex);
                    }
                  }
                }, '编辑')
              ]);
            } else {
              return h('i-switch', {
                props: {
                  value: !!self.productInfo.productGoodsList[realIndex].isAssemble,
                  disabled: (() => {
                    return self.isDisabled;
                  })()
                },
                on: {
                  'on-change': (val) => {
                    const assembleVal = !!val;
                    self.productInfo.productGoodsList[realIndex].isAssemble = assembleVal;
                    if (self.skuDataLocal[realIndex]) self.$set(self.skuDataLocal[realIndex], 'isAssemble', assembleVal);
                    // 开启组装时若 productGoodsAssembles 不存在，初始化为空数组
                    if (assembleVal && self.$common.isEmpty(self.productInfo.productGoodsList[realIndex].productGoodsAssembles)) {
                      self.$set(self.productInfo.productGoodsList[realIndex], 'productGoodsAssembles', []);
                      if (self.skuDataLocal[realIndex]) self.$set(self.skuDataLocal[realIndex], 'productGoodsAssembles', []);
                    }
                  }
                }
              });
            }
          }
        },
        {
          title: '产品类型',
          width: 125,
          key: 'productType',
          align: 'center',
          renderHeader: (h, params) => {
            return self.checkIdenticalDon(h, params, '产品类型', self.productInfo.productGoodsList, 'productTypeListValue', this.skuDataLocal);
          },
          render: (h, params) => {
            const realIndex = self.getRealIndex(params.index);
            return h('Select', {
              props: {
                multiple: true,
                filterable: true,
                transfer: true,
                value: self.productInfo.productGoodsList[realIndex].productTypeListValue,
                disabled: (() => {
                  return self.isDisabled;
                })()
              },
              on: {
                'on-change'(value) {
                  if (value.length > 1 && value.indexOf('01') > -1) {
                    value.forEach((i, j) => {
                      if (i === '01') {
                        value.splice(j, 1);
                      }
                    });
                    self.productInfo.productGoodsList[realIndex].productTypeListValue = value;
                    if (self.skuDataLocal[realIndex]) self.$set(self.skuDataLocal[realIndex], 'productTypeListValue', value);
                  } else if (value.length === 0) {
                    self.productInfo.productGoodsList[realIndex].productTypeListValue = ['01'];
                    if (self.skuDataLocal[realIndex]) self.$set(self.skuDataLocal[realIndex], 'productTypeListValue', ['01']);
                  } else {
                    self.productInfo.productGoodsList[realIndex].productTypeListValue = value;
                    if (self.skuDataLocal[realIndex]) self.$set(self.skuDataLocal[realIndex], 'productTypeListValue', value);
                  }
                }
              }
            }, productTypeData.map(i => {
              return h('Option', { props: { value: i.value } }, i.name);
            }));
          }
        },
        {
          title: 'UPC',
          key: 'upc',
          minWidth: 100,
          align: 'center',
          renderHeader: (h, params) => {
            return self.checkIdenticalDon(h, params, 'UPC', self.productInfo.productGoodsList, 'upc', this.skuDataLocal);
          },
          render: (h, params) => {
            const realIndex = self.getRealIndex(params.index);
            return h('Input', {
              props: {
                value: self.productInfo.productGoodsList[realIndex].upc,
                maxlength: 100,
                placeholder: '请输入' + 'UPC',
                disabled: (() => {
                  return self.isDisabled;
                })()
              },
              on: {
                'input': (val) => {
                  const trimVal = self.trim(val);
                  self.productInfo.productGoodsList[realIndex].upc = trimVal;
                  if (self.skuDataLocal[realIndex]) self.$set(self.skuDataLocal[realIndex], 'upc', trimVal);
                }
              }
            });
          }
        },
        {
          title: 'EAN',
          key: 'ean',
          width: 100,
          align: 'center',
          renderHeader: (h, params) => {
            return self.checkIdenticalDon(h, params, 'EAN', self.productInfo.productGoodsList, 'ean', this.skuDataLocal);
          },
          render: (h, params) => {
            const realIndex = self.getRealIndex(params.index);
            return h('Input', {
              props: {
                value: self.productInfo.productGoodsList[realIndex].ean,
                maxlength: 100,
                placeholder: '请输入' + 'EAN',
                disabled: (() => {
                  return self.isDisabled;
                })()
              },
              on: {
                'input': (val) => {
                  const trimVal = self.trim(val);
                  self.productInfo.productGoodsList[realIndex].ean = trimVal;
                  if (self.skuDataLocal[realIndex]) self.$set(self.skuDataLocal[realIndex], 'ean', trimVal);
                }
              }
            });
          }
        },
        {
          title: 'ISBN',
          key: 'isbn',
          width: 100,
          align: 'center',
          renderHeader: (h, params) => {
            return self.checkIdenticalDon(h, params, 'ISBN', self.productInfo.productGoodsList, 'isbn', this.skuDataLocal);
          },
          render: (h, params) => {
            const realIndex = self.getRealIndex(params.index);
            return h('Input', {
              props: {
                value: self.productInfo.productGoodsList[realIndex].isbn,
                maxlength: 100,
                placeholder: '请输入' + 'ISBN',
                disabled: (() => {
                  return self.isDisabled;
                })()
              },
              on: {
                'input': (val) => {
                  const trimVal = self.trim(val);
                  self.productInfo.productGoodsList[realIndex].isbn = trimVal;
                  if (self.skuDataLocal[realIndex]) self.$set(self.skuDataLocal[realIndex], 'isbn', trimVal);
                }
              }
            });
          }
        },
        {
          title: 'SKU生产要求',
          key: 'productionRequirement',
          width: 160,
          align: 'center',
          renderHeader: (h, params) => {
            return self.checkIdenticalDon(h, params, 'SKU生产要求', self.productInfo.productGoodsList, 'productionRequirement', this.skuDataLocal);
          },
          render: (h, params) => {
            const realIndex = self.getRealIndex(params.index);
            return h('dyt-input-tag', {
              style: {
                minWidth: 'auto',
              },
              props: {
                type: 'textarea',
                string: true,
                limit: 1,
                split: [],
                value: self.productInfo.productGoodsList[realIndex].productionRequirement,
                placeholder: '请输入SKU生产要求，特殊收货要求请用"【" "】"符号进行圈中, 最多200字符',
                disabled: (() => {
                  return self.isDisabled;
                })(),
                inputConfig: {
                  maxlength: 200,
                },
              },
              on: {
                'change': (val) => {
                  const trimVal = self.trim(val);
                  self.productInfo.productGoodsList[realIndex].productionRequirement = trimVal;
                  if (self.skuDataLocal[realIndex]) self.$set(self.skuDataLocal[realIndex], 'productionRequirement', trimVal);
                }
              }
            });
          }
        },
        {
          title: '胚衣SKU',
          key: 'embryonicClothSku',
          width: 160,
          align: 'center',
          render: (h, { row, index }) => {
            const realIndex = self.getRealIndex(index);
            return h('Input', {
              props: {
                value: self.productInfo.productGoodsList[realIndex].embryonicClothSku,
                maxlength: 100,
                placeholder: '请输入胚衣SKU',
                disabled: (() => {
                  return self.isDisabled;
                })()
              },
              on: {
                'input': (val) => {
                  const trimVal = self.trim(val);
                  self.productInfo.productGoodsList[realIndex].embryonicClothSku = trimVal;
                  if (self.skuDataLocal[realIndex]) self.$set(self.skuDataLocal[realIndex], 'embryonicClothSku', trimVal);
                }
              }
            });
          }
        },
        {
          title: '胚衣描述',
          key: 'embryonicClothDescription',
          width: 160,
          align: 'center',
          render: (h, { row, index }) => {
            const realIndex = self.getRealIndex(index);
            return h('Input', {
              props: {
                value: self.productInfo.productGoodsList[realIndex].embryonicClothDescription,
                maxlength: 100,
                placeholder: '请输入胚衣描述',
                disabled: (() => {
                  return self.isDisabled;
                })()
              },
              on: {
                'input': (val) => {
                  const trimVal = self.trim(val);
                  self.productInfo.productGoodsList[realIndex].embryonicClothDescription = trimVal;
                  if (self.skuDataLocal[realIndex]) self.$set(self.skuDataLocal[realIndex], 'embryonicClothDescription', trimVal);
                }
              }
            });
          }
        },
        {
          title: '印花图案url',
          key: 'printingImagePath',
          width: 160,
          align: 'center',
          render: (h, { row, index }) => {
            const realIndex = self.getRealIndex(index);
            return h('Input', {
              props: {
                value: self.productInfo.productGoodsList[realIndex].printingImagePath,
                maxlength: 100,
                placeholder: '请输入印花图案url',
                disabled: (() => {
                  return self.isDisabled;
                })()
              },
              on: {
                'input': (val) => {
                  const trimVal = self.trim(val);
                  self.productInfo.productGoodsList[realIndex].printingImagePath = trimVal;
                  if (self.skuDataLocal[realIndex]) self.$set(self.skuDataLocal[realIndex], 'printingImagePath', trimVal);
                }
              }
            });
          }
        },
        {
          title: '操作',
          fixed: 'right',
          align: 'center',
          key: 'options',
          width: 75,
          render: (h, params) => {
            const realIndex = self.getRealIndex(params.index);
            return h('div', [
              h('Button', {
                props: {
                  type: 'text',
                  disabled: (() => {
                    return self.isDisabled;
                  })()
                },
                on: {
                  click: () => {
                    // 操作本地副本，避免直接突变 prop
                    self.skuDataLocal.splice(realIndex, 1);
                    if (self.skuDataLocal.length !== 0) {
                      self.productInfo.productGoodsList.splice(realIndex, 1);
                    } else {
                      self.productInfo.productGoodsList[0].productGoodsSpecifications = [];
                    }
                    self.resetPageIfNeeded();
                    // 根据剩余 SKU 数据重建 skuPropertyListLocal 的 values，移除已不存在的属性值
                    self.skuPropertyListLocal.forEach((property, pIndex) => {
                      const usedValues = new Set();
                      self.skuDataLocal.forEach(item => {
                        if (item.productGoodsSpecifications && item.productGoodsSpecifications[pIndex]) {
                          usedValues.add(item.productGoodsSpecifications[pIndex].value);
                        }
                      });
                      const newValues = (property.values || []).filter(v => usedValues.has(v));
                      if (newValues.length !== (property.values || []).length) {
                        self.$set(property, 'values', newValues);
                      }
                    });
                    // 同步到父组件并更新 old 快照
                    self.saveEdit();
                    self.$emit('update:skuData', self.$common.copy(self.skuDataLocal));
                    self.$emit('update:skuPropertyList', self.$common.copy(self.skuPropertyListLocal));
                    self.$emit('update:productInfo', self.$common.copy(self.productInfo));
                  }
                }
              }, '删除')
            ]);
          }
        }
      ],
      columns1: [
        {
          title: '名称',
          slot: 'name',
          width: 200
        },
        {
          title: '属性值',
          slot: 'value'
        },
        {
          title: '操作',
          slot: 'operate',
          width: 80,
          align: 'center'
        }
      ],
      editVisible: false,
      tableReady: false,
      skuPageNum: 1,
      skuPageSize: 5,
      skuDataLocal: [],
      skuDataOld: [],
      skuPropertyListOld: [],
      skuPropertyListLocal: [],
      productInfoOld: {}
    };
  },
  mounted() {
    // 延迟渲染 Table，避免首次切换到多属性 Tab 时大量 render 函数同步执行阻塞主线程
    setTimeout(() => {
      this.tableReady = true;
    }, 50);
  },
  computed: {
    pagedSkuDataLocal() {
      const start = (this.skuPageNum - 1) * this.skuPageSize;
      return this.skuDataLocal.slice(start, start + this.skuPageSize);
    },
    getColorAll() {
      if (this.$common.isEmpty(this.colorList)) return [];
      return this.colorList.map(m => m.color);
    },
    getSizeVal() {
      if (this.$common.isEmpty(this.sizeList)) return [];
      return this.handSizeList(this.sizeList);
    },
    isAttrTips() {
      if (this.$common.isEmpty(this.skuPropertyListLocal)) return false;
      let isTips = false;
      this.skuPropertyListLocal.forEach(item => {
        if (!this.$common.isEmpty(item.values)) {
          item.values.forEach(val => {
            if (!this.getColorAll.includes(val) && !this.getSizeVal.includes(val)) {
              isTips = true;
            }
          });
        }
      });
      return isTips;
    }
  },
  watch: {
    /** 同步 skuData prop 到本地副本，避免 mixin 直接修改 prop */
    skuData: {
      immediate: true,
      deep: true,
      handler(val) {
        // 用 JSON 对比避免内容相同时重复赋值导致死循环
        const newStr = JSON.stringify(val || []);
        const oldStr = JSON.stringify(this.skuDataLocal);
        if (newStr !== oldStr) {
          this.skuDataLocal = this.deepCopy(val || []);
          // 仅在数据条数减少导致当前页越界时调整页码，
          // 避免 addTabData 等原地更新场景强制跳回第一页。
          this.resetPageIfNeeded();
        }
      }
    },
    /** 监听本地副本变化，同步 emit 回父组件 */
    skuDataLocal: {
      deep: true,
      handler(val) {
        const newStr = JSON.stringify(val);
        const oldStr = JSON.stringify(this.skuData);
        if (newStr !== oldStr) {
          this.$emit('update:skuData', this.deepCopy(val));
        }
      }
    },
    /** 同步 skuPropertyList prop 到本地副本 */
    skuPropertyList: {
      immediate: true,
      deep: true,
      handler(val) {
        const newStr = JSON.stringify(val || []);
        const oldStr = JSON.stringify(this.skuPropertyListLocal);
        if (newStr !== oldStr) {
          this.skuPropertyListLocal = this.deepCopy(val || []);
        }
      }
    },
    /** 监听本地副本变化，同步 emit 回父组件 */
    skuPropertyListLocal: {
      deep: true,
      handler(val) {
        const newStr = JSON.stringify(val);
        const oldStr = JSON.stringify(this.skuPropertyList);
        if (newStr !== oldStr) {
          this.$emit('update:skuPropertyList', this.deepCopy(val));
        }
      }
    }
  },
  methods: {
    getRealIndex(renderIndex) {
      return (this.skuPageNum - 1) * this.skuPageSize + renderIndex;
    },
    resetPageIfNeeded() {
      const totalPages = Math.ceil(this.skuDataLocal.length / this.skuPageSize);
      if (totalPages === 0) {
        this.skuPageNum = 1;
      } else if (this.skuPageNum > totalPages) {
        this.skuPageNum = totalPages;
      }
    },
    // 覆写 mixin 的 delSkuPropertyValue，将其中的 this.skuData = ... 改为修改本地副本
    delSkuPropertyValue(currentSkuProperty, currentPropertyValue, index) {
      let self = this;
      if (self.sizeChartdata && self.sizeChartdata.length > 0) {
        self.sizeChartdata.forEach((item, ids) => {
          if (item.sizeCode === currentPropertyValue) {
            self.sizeChartdata.splice(ids, 1);
          }
        });
      }
      let validOtherPropertyValueCount = 0;
      let currentPropertyValueIsValid = false;
      self.productInfo.productGoodsList.forEach((productGoods, i) => {
        productGoods.productGoodsSpecifications.forEach((productGoodsSpecification, i) => {
          if (currentSkuProperty.values.indexOf(productGoodsSpecification.value) !== -1 && productGoodsSpecification.value !== currentPropertyValue && productGoodsSpecification.name === currentSkuProperty.name) {
            validOtherPropertyValueCount += i + 1;
          }
          if (productGoodsSpecification.name === currentSkuProperty.name && productGoodsSpecification.value === currentPropertyValue) {
            currentPropertyValueIsValid = true;
          }
        });
      });
      currentSkuProperty.values.splice(index, 1);
      if (!currentPropertyValueIsValid) return;
      let filterResult = self.productInfo.productGoodsList.filter((productGoods, i) => {
        let productGoodsSpecificationIndex = -1;
        productGoods.productGoodsSpecifications.forEach((productGoodsSpecification, i) => {
          if (productGoodsSpecification.name === currentSkuProperty.name && productGoodsSpecification.value === currentPropertyValue) {
            productGoodsSpecificationIndex = i;
          }
        });
        if (productGoodsSpecificationIndex === -1) return true;
        else if (validOtherPropertyValueCount > 0) return false;
        productGoods.productGoodsSpecifications.splice(productGoodsSpecificationIndex, 1, {});
        if (this.$common.isEmpty(productGoods.productGoodsSpecifications, true)) return false;
        return true;
      });
      if (filterResult.length !== 0) {
        self.productInfo.productGoodsList = self.deepCopy(filterResult);
      } else if (self.skuDataLocal.length !== 0) {
        self.productInfo.productGoodsList = [self.deepCopy(self.skuDataLocal[0])];
        self.productInfo.productGoodsList[0].productGoodsSpecifications = [];
      }
      let valueList = [];
      let tableValueList = [];
      let deleteValue = '';
      // 使用本地副本，避免直接突变 skuPropertyList prop
      for (let i in self.skuPropertyListLocal) {
        valueList = [...valueList, ...self.skuPropertyListLocal[i].values];
      }
      for (let i in filterResult) {
        for (let j in filterResult[i].productGoodsSpecifications) {
          tableValueList.push(filterResult[i].productGoodsSpecifications[j].value || []);
        }
      }
      for (let i in valueList) {
        if (tableValueList.indexOf(valueList[i]) === -1) deleteValue = valueList[i];
      }
      for (let i in self.skuPropertyListLocal) {
        for (let j in self.skuPropertyListLocal[i].values) {
          if (self.skuPropertyListLocal[i].values[j] == deleteValue) {
            self.skuPropertyListLocal[i].values.splice(j, 1);
          }
        }
      }
      // 统一在末尾同步 productGoodsList 和 skuDataLocal，保持一致
      self.skuDataLocal = self.deepCopy(self.productInfo.productGoodsList);
      this.skuPageNum = 1;
      // 同步到父组件，并更新 old 快照，确保关闭弹窗时不回滚本次删除
      this.saveEdit();
      this.$emit('update:skuData', this.$common.copy(this.skuDataLocal));
      this.$emit('update:skuPropertyList', this.$common.copy(this.skuPropertyListLocal));
      this.$emit('update:productInfo', this.$common.copy(this.productInfo));
    },
    // 覆写 mixin 的 reloadSkuData，将其中的 this.skuData = ... 改为修改本地副本
    reloadSkuData(currentSkuProperty, currentPropertyValue, tagIndex) {
      this.$nextTick(() => {
        let goodsObj = {};
        let colorSizeObj = {};
        let tableList = [];
        let defualtList = this.deepCopy(this.productInfo.productGoodsList || []);
        defualtList.forEach(productGoods => {
          const sizeKey = (productGoods.productGoodsSpecifications || []).map(m => {
            return `${m.name}${m.value}`;
          }).join('');
          this.$set(colorSizeObj, sizeKey, this.$common.copy(productGoods));
        });
        if (!this.$common.isEmpty(this.productInfoPrototype) && !this.$common.isEmpty(this.productInfoPrototype.productGoodsList)) {
          goodsObj = this.deepCopy(this.productInfoPrototype.productGoodsList[0] || {});
        }
        const skuPropertyList = (this.$common.isEmpty(this.skuPropertyListLocal) ? [] : this.skuPropertyListLocal);
        const tableRows = this.cartesianProduct(skuPropertyList.map(m => {
          const arr = (this.$common.isEmpty(m.values) ? [''] : m.values).map((val) => {
            return { name: m.name || '', value: val || '' };
          });
          return arr;
        }));
        tableRows.forEach((row) => {
          let colorSize = '';
          if (this.$common.isArray(row)) {
            colorSize = row.map(m => `${m.name}${m.value}`).join('');
          } else {
            colorSize = `${row.name}${row.value}`;
          }
          if (!this.$common.isEmpty(colorSizeObj[colorSize])) {
            const newRow = (colorSizeObj[colorSize].productGoodsSpecifications || row);
            tableList.push({
              ...colorSizeObj[colorSize],
              productGoodsSpecifications: this.$common.isArray(newRow) ? newRow : [newRow]
            });
          } else {
            const isHidden = (this.$common.isArray(row) ? row : [row || {}]).find(item => {
              if (item.name == 'Color' && !this.isOldData) return !this.getColorAll.includes(item.value);
              else if (item.name == 'Size' && !this.isOldData) return !this.getSizeVal.includes(item.value);
              return false;
            });
            this.$common.isEmpty(isHidden) && tableList.push({
              ...goodsObj,
              productGoodsSpecifications: this.$common.isArray(row) ? row : [row]
            });
          }
        });
        this.productInfo.productGoodsList = tableList;
        // 修改本地副本，而非直接突变 prop
        this.skuDataLocal = this.deepCopy(tableList);
        this.skuPageNum = 1;
      });
    },
    editAttributes(info) {
      if (!this.$common.isEmpty(info.sizeGroupNo)) {
        this.$set(this.productInfo, 'sizeGroupNo', info.sizeGroupNo);
      }
      this.$nextTick(() => {
        let sizeGroupNo = this.productInfo.sizeGroupNo;
        this.editVisible = true;
        if (!this.$common.isEmpty(sizeGroupNo) && !this.$common.isEmpty(this.sizeList)) {
          this.sizeList.forEach((item, index) => {
            this.$set(this.sizeList[index], 'disabled', sizeGroupNo != item.sizeGroupNo);
          })
        }
        for (let i in this.skuPropertyListLocal) {
          this.skuPropertyListLocal[i].isEdit = true;
        }
        this.skuDataOld = this.deepCopy(this.skuDataLocal);
        this.skuPropertyListOld = this.deepCopy(this.skuPropertyListLocal);
        this.productInfoOld = this.deepCopy(this.productInfo);
      })
    },
    addAttribute(item) {
      if (this.$common.isEmpty(this.productInfo.sizeGroupNo) && !this.isOldData && !this.$common.isEmpty(this.sizeList)) {
        this.editVisible = false;
        this.$nextTick(() => {
          this.$emit('bind-size-group');
        })
        return;
      }
      item.isEdit = false;
    },
    closeEdit() {
      this.$emit('update:skuData', this.$common.copy(this.skuDataOld));
      this.$emit('update:skuPropertyList', this.$common.copy(this.skuPropertyListOld));
      this.$emit('update:productInfo', this.$common.copy(this.productInfoOld));
    },
    saveEdit() {
      this.skuDataOld = this.$common.copy(this.skuDataLocal);
      this.skuPropertyListOld = this.$common.copy(this.skuPropertyListLocal);
      this.productInfoOld = this.$common.copy(this.productInfo);
    },
    deleteTag(row, Dvalue, Dindex) {
      let skuDataNew = this.skuDataLocal.filter(k => {
        if (k.productGoodsSpecifications[Dindex].value !== Dvalue) {
          return k
        }
      })
      // 删除标签
      for (let i in row.values) {
        if (row.values[i] === Dvalue) {
          row.values.splice(i, 1)
        }
      }
      this.$emit('update:skuData', skuDataNew);
    },
    handSizeList(data, oldVal = [], key) {
      let valList = [...oldVal];
      data.forEach(item => {
        if (!item.disabled) {
          if (item.children) {
            valList = [...valList, ...this.handSizeList(item.children, valList, 'key')];
          } else {
            valList.push(item.size);
          }
        }
      });
      return this.$common.arrRemoveRepeat(valList);
    }
  }
};
</script>

<style lang="less" scoped>
.tag-content-multiattribute {
  :deep(.propertyCont){
    /* SKU图片列 - 多语言展示 */
    .sku-img-cell {
      cursor: pointer;
      padding: 4px 2px;
      user-select: none;
    }
    .sku-img-thumbs {
      position: relative;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: flex-end;
      margin-bottom: 4px;
      min-height: 32px;
    }
    .sku-img-badge {
      background: #ed4014;
      color: #fff;
      font-size: 11px;
      padding: 1px 4px;
      border-radius: 8px;
      line-height: 1.4;
      pointer-events: none;
    }
    .sku-lang-tags {
      display: grid;
      gap: 2px;
      justify-content: center;
      grid-template-columns: repeat(3, auto);
    }
    .sku-lang-tag {
      display: inline-block;
      padding: 0 4px;
      border: 1px solid #dcdfe6;
      border-radius: 3px;
      font-size: 11px;
      color: #bbb;
      line-height: 18px;
    }
    .sku-lang-tag.active {
      border-color: #2d8cf0;
      color: #2d8cf0;
      background: #e8f4ff;
    }
  }
}
</style>
